import {debounce} from 'lodash';
import {Controller} from "@hotwired/stimulus";

/**
 * Mixin for detecting left panel state changes (expanded/collapsed).
 * Note that you can use this mixin only for Stimulus controllers.
 *
 * Usage:
 * import {useLeftPanelChangeListener} from "./mixins/use_left_panel_change_listener.js";
 *
 * export default class extends Controller {
 *   connect() {
 *     useLeftPanelChangeListener(this);
 *   }
 *
 *   onLeftPanelChange() {
 *     // callback function
 *   }
 * }
 */
export function useLeftPanelChangeListener(controller, options = {}) {
  const {
    debounceDelay = 100,
    callback = 'onLeftPanelChange'
  } = options;

  if (!(controller instanceof Controller)) {
    console.error('useLeftPanelChangeListener: param controller is not instance of Stimulus Controller');
    throw new Error("useLeftPanelChangeListener: param controller is not instance of Stimulus Controller");
  }

  if (typeof controller[callback] !== 'function') {
    console.error(`useLeftPanelChangeListener: controller.${callback} method is required`);
    throw new Error(`useLeftPanelChangeListener: controller.${callback} method is required`);
  }

  controller._leftPanelChangeListener = debounce(() => {
    controller[callback]();
  }, debounceDelay);

  window.addEventListener('left-panel-change', controller._leftPanelChangeListener);

  const originalDisconnect = controller.disconnect.bind(controller);
  controller.disconnect = function() {
    window.removeEventListener('left-panel-change', controller._leftPanelChangeListener);
    originalDisconnect();
  };
}